import { makeAutoObservable } from 'mobx';

export interface IReport<T> {
	totalRows: number;
	totalFilteredRows: number;
	summary: T;
	data: T[];
	prevReport: IReport<T> | undefined;
}

export class ReportModel<T> {
	totalRows: number;
	totalFilteredRows: number;
	summary: T;
	data: T[];
	prevReport: ReportModel<T> | undefined;

	constructor(performanceResponse: IReport<T>, makeObservable = true) {
		this.totalRows = performanceResponse?.totalRows;
		this.totalFilteredRows = performanceResponse?.totalFilteredRows;
		this.summary = performanceResponse?.summary;
		this.data = performanceResponse?.data;
		this.prevReport = performanceResponse?.prevReport ? new ReportModel<T>(performanceResponse?.prevReport, false) : undefined;

		makeObservable && makeAutoObservable(this);
	}

	getTotalRows(): number | undefined {
		return this.totalRows;
	}

	getTotalFilteredRows(): number | undefined {
		return this.totalFilteredRows;
	}

	getSummary(): T | undefined {
		return this.summary;
	}

	getData(): T[] | undefined {
		return this.data;
	}

	getPrevReport(): ReportModel<T> | undefined {
		return this.prevReport;
	}
}
